// extracted by mini-css-extract-plugin
export default {"BtnCashOut":"AmountTab_BtnCashOut__+IDoB","Dashboard":"AmountTab_Dashboard__U0Bd5"};